var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-card" },
    _vm._l(_vm.posts, function(post) {
      return _c("div", { key: post.id, staticClass: "container-card" }, [
        _c("div", { staticClass: "picture" }, [
          post.type && post.type == "NATIVE_DOCUMENT"
            ? _c("i", { staticClass: "fa-regular fa-file-pdf" })
            : post.attachment_url
            ? _c("img", { attrs: { src: post.attachment_url } })
            : _c("i", { staticClass: "fa-regular fa-image-slash" })
        ]),
        _c("div", { staticClass: "content-card" }, [
          _c("div", { staticClass: "container-date" }, [
            _c("p", { staticClass: "date" }, [
              _vm._v(_vm._s(_vm.getFormatDate(post.created_time)))
            ])
          ]),
          _c("h4", { staticClass: "title" }, [_vm._v(_vm._s(post.message))]),
          _c("div", { staticClass: "table" }, [
            _c("table", [
              post.post_impressions
                ? _c("tr", [
                    _c("td", [_vm._v("Impressions")]),
                    _c("td", { staticClass: "value" }, [
                      _vm._v(_vm._s(post.post_impressions))
                    ])
                  ])
                : _vm._e(),
              post.interactions
                ? _c("tr", [
                    _c("td", [_vm._v("Interactions")]),
                    _c("td", { staticClass: "value" }, [
                      _vm._v(_vm._s(post.interactions))
                    ])
                  ])
                : _vm._e(),
              post.post_reactions_sum
                ? _c("tr", [
                    _c("td", [_vm._v("Réactions")]),
                    _c("td", { staticClass: "value" }, [
                      _vm._v(_vm._s(post.post_reactions_sum))
                    ])
                  ])
                : _vm._e(),
              _c("tr", [
                _c("td", [_vm._v("Commentaires")]),
                _c("td", { staticClass: "value" }, [
                  _vm._v(_vm._s(post.comments_count ? post.comments_count : 0))
                ])
              ]),
              _c("tr", [
                _c("td", [_vm._v("Partages")]),
                _c("td", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(post.shares_count ? post.post_reactions_sum : 0)
                  )
                ])
              ]),
              post.link_clicks
                ? _c("tr", [
                    _c("td", [_vm._v("Clics")]),
                    _c("td", { staticClass: "value" }, [
                      _vm._v(_vm._s(post.link_clicks))
                    ])
                  ])
                : _vm._e()
            ])
          ])
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }